module.exports = __webpack_public_path__ + "static/how-technology-can-help-create-a-contactless-workplace-experience-707927ca9bb79ed6fd5cadae57d6bdd7.png";